import { useSelector } from 'react-redux'
import { t } from 'ttag'
import { Link } from 'react-router-dom'

import LoadingIndicator from '../../components/LoadingIndicator'

const JobOpeningComparison = props => {
  const { error, fluidContainer = false } = props
  const comparisons = useSelector(
    state => state.jobs.comparisonResponse.result?.comparisons
  )

  if (!comparisons) {
    return <LoadingIndicator newSiteLook={dynamicValues.newSiteLook} />
  }

  if (error) {
    return (
      <div className="container">
        <div className="alert alert-warning" role="alert">
          <h3>{error}</h3>
        </div>
      </div>
    )
  }

  return (
    <div className={fluidContainer ? 'container-fluid' : 'container'}>
      <table id="comparison" className="tbl">
        <thead>
          <tr>
            <th className="comparison-heading">
              <span className="sr-only">{t`Comparison Attribute`}</span>
            </th>
            {(comparisons || []).map((data, idx) => (
              <th key={`comparison${idx}`} className="occupation-title">
                <Link
                  to={data?.url}
                  style={{ fontWeight: 'bold' }}
                  className="occupation-link regular-match">
                  {data?.title}
                </Link>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr className="odd">
            <th scope="row" className="comparison-heading">{t`Company`}</th>
            {(comparisons || []).map((data, idx) => (
              <td key={`company${idx}`} className="occupation-title">
                {data.companyUrl ? (
                  <Link to={data.companyUrl}>{data.company}</Link>
                ) : (
                  data.company
                )}
              </td>
            ))}
          </tr>
          <tr className="even">
            <th scope="row" className="comparison-heading">{t`Location`}</th>
            {(comparisons || []).map((data, idx) => (
              <td key={`location${idx}`} className="occupation-title">
                {data?.city}, {data.state}
              </td>
            ))}
          </tr>
          <tr className="odd">
            <th scope="row" className="comparison-heading">{t`Internship`}</th>
            {(comparisons || []).map((data, idx) => (
              <td key={`internship${idx}`} className="occupation-title">
                {data.internship ? (
                  <div>
                    <i className="check"></i> <span className="sr-only">{t`yes`}</span>
                  </div>
                ) : (
                  <span className="sr-only">{t`no`}</span>
                )}
              </td>
            ))}
          </tr>
          <tr className="even">
            <th scope="row" className="comparison-heading">{t`Apprenticeship`}</th>
            {(comparisons || []).map((data, idx) => (
              <td key={`apprentice${idx}`} className="occupation-title">
                {data?.apprenticeship ? (
                  <div>
                    <i className="check"></i> <span className="sr-only">{t`yes`}</span>
                  </div>
                ) : (
                  <span className="sr-only">{t`no`}</span>
                )}
              </td>
            ))}
          </tr>

          <tr className="odd">
            <th scope="row" className="comparison-heading">{t`Cluster`}</th>
            {(comparisons || []).map((data, idx) => (
              <td key={`cluste${idx}`} className="occupation-title">
                {data?.cluster?.name}
              </td>
            ))}
          </tr>
          <tr className="odd">
            <th scope="row" className="comparison-heading">{t`Occupations`}</th>
            {(comparisons || []).map((data, idx) => (
              <td key={`occs${idx}`} className="possible-occs vatop">
                <ul className="fa-ul">
                  {data?.occupations?.map((occ, idx2) => (
                    <li key={`occ${idx2}`}>
                      <i aria-hidden="true" className="fa-li fal fa-briefcase"></i>
                      <Link to={occ.url} className="occupation-link regular-match title">
                        {occ.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </td>
            ))}
          </tr>
          <tr className="even">
            <th scope="row" className="comparison-heading">{t`Date Posted`}</th>
            {(comparisons || []).map((data, idx) => (
              <td key={`posted${idx}`} className="occupation-title">
                {new Date(data?.datePosted).toLocaleDateString()}
              </td>
            ))}
          </tr>
        </tbody>
        <tfoot>
          <tr className="even">
            <th></th>
            {(comparisons || []).map((data, idx) => (
              <th className="profile-link" key={`opening${idx}`}>
                <Link to={data?.url} className="submit">
                  {t`View Job Opening`}
                </Link>
              </th>
            ))}
          </tr>
        </tfoot>
      </table>
    </div>
  )
}

export { JobOpeningComparison }
